import { ModelBase } from '../../core/model/model-base';
import { AdjustmentKind, ArticleUnit, ArticleTimeUnitKind, ArticleTimeUnitKindToString, AdjustmentKindToString } from './const/enums';
import { Money } from '../../core/model/money';
import { Currencies } from '../../core/pipe/currency.pipe';
import { ArticleCoding } from './article-coding';
import { Translation } from '../../core/model/translation';

export class Article extends ModelBase {
  constructor(context?: any) {
    super();
    if (context) {
      this.id = context.id;
      this.price = context.price ? new Money(context.currencyCode, context.price.amount) : new Money(context.currencyCode, null);
      this.articleGroupId = context.articleGroupId;
      this.articleGroupName = context.articleGroupName;
      this.bookTurnoverOnInvoiceDate = context.bookTurnoverOnInvoiceDate;
      this.isReduction = context.isReduction;
      this.caption = context.caption;
      this.code = context.code;
      this.currencyCode = context.currencyCode;
      this.dwellingCategory = context.dwellingCategory;
      this.includeInContractualRent = context.includeInContractualRent;
      this.invoiceTexts = (context.invoiceTexts ?? []).map(t => new Translation(t.cultureName, t.translationText));
      this.claimAccountNumber = context.claimAccountNumber;
      this.incomeAccountNumber = context.incomeAccountNumber;
      this.vatAccountNumber = context.vatAccountNumber;
      this.rentLossAccountNumber = context.rentLossAccountNumber;
      this.rentLossIncomAccountNumber = context.rentLossIncomAccountNumber;
      this.incomePeriodizationAccountNumber = context.incomePeriodizationAccountNumber;
      this.otherCategory = context.otherCategory;
      this.parkingCategory = context.parkingCategory;
      this.premisesCategory = context.premisesCategory;
      this.price = context.price;
      this.invoiceRowSortOrder = context.invoiceRowSortOrder;
      this.timeUnit = context.timeUnit;
      this.allowDisableDwelling = context.allowDisableDwelling;
      this.allowDisableOtherRentalObject = context.allowDisableOtherRentalObject;
      this.allowDisableParking = context.allowDisableParking;
      this.allowDisablePremises = context.allowDisablePremises;
      this.articleUsed = context.articleUsed;
      this.codings = context.codings;
      this.adjustment = context.adjustment;
      this.unit = context.unit;
      this.vatPercent = context.vatPercent;
      this.favorite = context.favorite;
      this.voluntaryVat = context.voluntaryVat;
      this.isPropertyTax = context.isPropertyTax;
      this.isRetroactiveForPropertyTax = context.isRetroactiveForPropertyTax;
      return;
    }
    this.currencyCode = Currencies.SEK;
    this.price = new Money(this.currencyCode, null);
    this.adjustment = AdjustmentKind.None;
    this.timeUnit = ArticleTimeUnitKind.Month;
    this.includeInContractualRent = false;
    this.unit = ArticleUnit.None;
    this.vatPercent = 0;
    this.invoiceRowSortOrder = 1;
    this.invoiceTexts = [];
  }

  codings: ArticleCoding[];
  adjustment: AdjustmentKind;
  get adjustmentCaption(): string {
    return AdjustmentKindToString(this.adjustment);
  }
  articleGroupId: string;
  articleGroupName: string;
  bookTurnoverOnInvoiceDate: boolean = false;
  isReduction: boolean = false;
  favorite: boolean = false;
  caption: string;
  code: string;
  currencyCode: string;
  dwellingCategory = false;
  includeInContractualRent: boolean;
  invoiceTexts: Translation[];
  claimAccountNumber: string;
  incomeAccountNumber: string;
  vatAccountNumber: string;
  rentLossAccountNumber: string;
  rentLossIncomAccountNumber: string;
  incomePeriodizationAccountNumber: string;
  otherCategory = false;
  parkingCategory = false;
  premisesCategory = false;
  price: Money;
  invoiceRowSortOrder: number;
  timeUnit: ArticleTimeUnitKind;
  allowDisableDwelling = true;
  allowDisableOtherRentalObject = true;
  allowDisableParking = true;
  allowDisablePremises = true;
  articleUsed = false;
  voluntaryVat = false;
  isPropertyTax: boolean = false;
  isRetroactiveForPropertyTax: boolean = false;

  get timeUnitCaption(): string {
    return ArticleTimeUnitKindToString(this.timeUnit);
  }
  unit: ArticleUnit;
  private _vatPercent: number;
  get vatPercent(): number {
    return this._vatPercent;
  }
  set vatPercent(value: number) {
    if (typeof value === 'string') {
      this._vatPercent = Number.parseFloat((value as string).replace(' ', '').replace(',', '.'));
    } else {
      this._vatPercent = value;
    }
  }

  toJSON() {
    return {
      id: this.id,
      articleGroupId: this.articleGroupId,
      adjustment: this.adjustment,
      bookTurnoverOnInvoiceDate: this.bookTurnoverOnInvoiceDate,
      isReduction: this.isReduction,
      caption: this.caption,
      code: this.code,
      currencyCode: this.currencyCode,
      dwellingCategory: this.dwellingCategory,
      includeInContractualRent: this.includeInContractualRent,
      invoiceTexts: this.invoiceTexts,
      otherCategory: this.otherCategory,
      parkingCategory: this.parkingCategory,
      premisesCategory: this.premisesCategory,
      price: this.price,
      invoiceRowSortOrder: this.invoiceRowSortOrder,
      timeUnit: this.timeUnit,
      unit: this.unit,
      codings: this.codings,
      vatPercent: this.vatPercent,
      voluntaryVat: this.voluntaryVat,
      favorite: this.favorite,
      isPropertyTax: this.isPropertyTax,
      isRetroactiveForPropertyTax: this.isRetroactiveForPropertyTax,
    };
  }
  toString() {
    if (!this.code || !this.caption) {
      return '';
    }
    return `${this.code} ${this.caption}`;
  }
}
